import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { FiFileText } from 'react-icons/fi';
import { getPageBySlug } from '../api/publicApi';
import useFetch from '../hooks/useFetch';
import { SkeletonBox } from '../components/Skeleton';
import { cleanHtmlContent } from '../utils/htmlUtils';

export default function PageDetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const { data, loading, error } = useFetch(getPageBySlug, slug, [slug]);

  const page = data?.data || data || null;

  return (
    <div className="page-detail-shell">
      <div className="page-detail-inner">
        <button className="contact-back-link" style={{ marginBottom: 20 }} onClick={() => navigate(-1)}>
          <FaArrowLeft size={12} /> Retour
        </button>

        {loading ? (
          <div>
            <SkeletonBox height={32} width="50%" style={{ marginBottom: 16 }} />
            <SkeletonBox height={14} style={{ marginBottom: 10 }} />
            <SkeletonBox height={14} width="90%" style={{ marginBottom: 10 }} />
            <SkeletonBox height={14} width="75%" style={{ marginBottom: 10 }} />
            <SkeletonBox height={14} style={{ marginBottom: 10 }} />
            <SkeletonBox height={14} width="85%" />
          </div>
        ) : error ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>
            <FiFileText size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
            <p>Impossible de charger cette page.</p>
          </div>
        ) : !page ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>
            <FiFileText size={36} style={{ display: 'block', margin: '0 auto 12px' }} />
            <p>Page introuvable.</p>
          </div>
        ) : (
          <div className="page-detail-content">
            <h2 className="page-detail-title">{page.titre}</h2>
            <div
              className="page-detail-body"
              dangerouslySetInnerHTML={{ __html: cleanHtmlContent(page.contenu) }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
